import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../../api/endpoints";
import axiosInstance from "../../../api/axiosInstance";

export const fetchRecruiterDashboardData = createAsyncThunk(
  "recruiterdashboard/fetchRecruiterDashboardData",
  async (recruterId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        endpoints.dashboarddata,
        recruterId
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

const recruiterDashboardSlice = createSlice({
  name: "recruiterdashboard",
  initialState: {
    dashboardData: null,
    loading: true,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecruiterDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRecruiterDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardData = action.payload.data;
      })
      .addCase(fetchRecruiterDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default recruiterDashboardSlice.reducer;
